import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { CalendarViewType, PanelViewType, TimePanelSource } from '../store/schema/TimePanelStore';
import { ClientItemId } from 'owa-client-ids';
import {
    Datapoints,
    TimePanelTarget,
    getTimePanelOptions,
    getTimePanelCustomData,
} from '../datapoints';
import { getOwaWorkload, getWorkloadName } from 'owa-workloads';

export const initializePanelTelemetryData = action('initializePanelTelemetryData');

export const loadPanel = action('loadTimePanel', (source: TimePanelSource) => ({ source }));

export const panelLoaded = action('timePanelLoaded', (source: TimePanelSource) =>
    addDatapointConfig({
        name: 'timePanelActionOpen',
        options: getTimePanelOptions,
        customData: getTimePanelCustomData({
            workload: getOwaWorkload(),
            workloadName: getWorkloadName(),
            source: source,
        }),
    })
);

export const panelClosed = action('timePanelClosed', () =>
    addDatapointConfig(Datapoints.timePanelActionClose)
);

export const updateSelectedCalendarEvent = action(
    'updateSelectedCalendarEvent',
    (selectedCalendarEventId: ClientItemId) => ({ selectedCalendarEventId })
);

export const openDeeplink = action('openDeeplink', (target: TimePanelTarget) =>
    addDatapointConfig({
        name: 'timePanelActionDeeplink',
        options: getTimePanelOptions,
        customData: getTimePanelCustomData({ target }),
    })
);

/**
 * Actions for view stack
 */

export const pushNewView = action('pushNewView', (newView: CalendarViewType) => ({
    newView,
}));

export const updateCurrentView = action('updateCurrentView', (updatedView: CalendarViewType) => ({
    updatedView,
}));

export const updatePanelView = action('updatePanelView', (updatedView: PanelViewType) =>
    addDatapointConfig(
        {
            name: 'timePanelActionSwitchView',
            options: getTimePanelOptions,
            customData: getTimePanelCustomData({ updatedView }),
        },
        {
            updatedView,
        }
    )
);

export const popView = action('popView');
